import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "src/common/axiosInstance";
import { CompareDataBy } from "./reducer";

// Payload types

interface CompareDataPayload {
  exchangeName:    string;
  lineItemIds:     string[];
  range1Start:     string;
  range1End:       string;
  range2Start:     string;
  range2End:       string;
  selectedMetrics: string[];
  dataBy:          CompareDataBy;
}

// Main compare — returns widget totals + graph for both date ranges.

export const fetchCompareData = createAsyncThunk(
  'compare/fetchCompareData',
  async (payload: CompareDataPayload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/compare-data', {
        line_item_ids:    payload.lineItemIds,
        range1_start:     payload.range1Start,
        range1_end:       payload.range1End,
        range2_start:     payload.range2Start,
        range2_end:       payload.range2End,
        selected_metrics: payload.selectedMetrics,
        data_by:          payload.dataBy,
      });
      return { ...response.data, exchangeName: payload.exchangeName };
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error ?? error.message ?? 'Failed to fetch compare data'
      );
    }
  }
);

// Graph-only refresh — called when Data By changes (widgets unaffected).

export const fetchCompareGraphData = createAsyncThunk(
  'compare/fetchCompareGraphData',
  async (payload: CompareDataPayload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/compare-graph', {
        line_item_ids:    payload.lineItemIds,
        range1_start:     payload.range1Start,
        range1_end:       payload.range1End,
        range2_start:     payload.range2Start,
        range2_end:       payload.range2End,
        selected_metrics: payload.selectedMetrics,
        data_by:          payload.dataBy,
      });
      return { ...response.data, exchangeName: payload.exchangeName };
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error ?? error.message ?? 'Failed to fetch graph data'
      );
    }
  }
);
